import moment from 'moment';
import { Gender } from '../models/eums/gender';
import { PersonRole } from '../models/eums/personRole';
import appStore from '../stores/index';

export function getGender(genderCode: Gender) {
  switch (genderCode) {
    case Gender.F:
      return 'Female';
    case Gender.M:
      return 'Male';
    case Gender.U:
    default:
      return 'Undefined';
  }
}

export function getGenderCode(gender: string) {
  switch (gender) {
    case 'Female':
      return Gender.F;
    case 'Male':
      return Gender.M;
    case 'Undefined':
      return Gender.U;
    default:
      return undefined;
  }
}

export function getAge(birthDate: Date) {
  return moment().diff(birthDate, 'years', false);
}

export function getFullName(firstName?: string, lastName?: string) {
  return `${firstName || ''} ${lastName || ''}`;
}

export function personHasRole(role: PersonRole) {
  const { personRoles } = appStore.getState().auth;
  if (!personRoles) return false;

  return personRoles.includes(role);
}
